export const DashBoardIcon = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5586_217)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H10C10.4142 3.25 10.75 3.58579 10.75 4V12C10.75 12.4142 10.4142 12.75 10 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12V4ZM4.75 4.75V11.25H9.25V4.75H4.75Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H10C10.4142 15.25 10.75 15.5858 10.75 16V20C10.75 20.4142 10.4142 20.75 10 20.75H4C3.58579 20.75 3.25 20.4142 3.25 20V16ZM4.75 16.75V19.25H9.25V16.75H4.75Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.25 12C13.25 11.5858 13.5858 11.25 14 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12V20C20.75 20.4142 20.4142 20.75 20 20.75H14C13.5858 20.75 13.25 20.4142 13.25 20V12ZM14.75 12.75V19.25H19.25V12.75H14.75Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.25 4C13.25 3.58579 13.5858 3.25 14 3.25H20C20.4142 3.25 20.75 3.58579 20.75 4V8C20.75 8.41421 20.4142 8.75 20 8.75H14C13.5858 8.75 13.25 8.41421 13.25 8V4ZM14.75 4.75V7.25H19.25V4.75H14.75Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5586_217">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AffilicateIcon = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5586_266)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0555 11.0555C10.5712 10.5397 11.2707 10.25 12 10.25C12.7293 10.25 13.4288 10.5397 13.9445 11.0555C14.4603 11.5712 14.75 12.2707 14.75 13C14.75 13.7293 14.4603 14.4288 13.9445 14.9445C13.4288 15.4603 12.7293 15.75 12 15.75C11.2707 15.75 10.5712 15.4603 10.0555 14.9445C9.53973 14.4288 9.25 13.7293 9.25 13C9.25 12.2707 9.53973 11.5712 10.0555 11.0555ZM12 11.75C11.6685 11.75 11.3505 11.8817 11.1161 12.1161C10.8817 12.3505 10.75 12.6685 10.75 13C10.75 13.3315 10.8817 13.6495 11.1161 13.8839C11.3505 14.1183 11.6685 14.25 12 14.25C12.3315 14.25 12.6495 14.1183 12.8839 13.8839C13.1183 13.6495 13.25 13.3315 13.25 13C13.25 12.6685 13.1183 12.3505 12.8839 12.1161C12.6495 11.8817 12.3315 11.75 12 11.75Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L13.9803 12.0803C13.6874 12.3732 13.2126 12.3732 12.9197 12.0803C12.6268 11.7874 12.6268 11.3126 12.9197 11.0197L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.70441C10.2882 4.70441 8.61888 5.23686 7.22324 6.22796C5.8276 7.21907 4.77481 8.61976 4.21076 10.2359C3.64671 11.8521 3.59934 13.6037 4.07521 15.2479C4.52726 16.8099 5.43021 18.2015 6.66817 19.25H17.3318C18.5698 18.2015 19.4727 16.8099 19.9248 15.2479C20.4007 13.6037 20.3533 11.8521 19.7892 10.2359C19.2252 8.61976 18.1724 7.21907 16.7768 6.22796C15.3811 5.23686 13.7118 4.70441 12 4.70441ZM6.35474 5.00497C8.00413 3.83366 9.97702 3.20441 12 3.20441C14.023 3.20441 15.9959 3.83366 17.6453 5.00497C19.2947 6.17629 20.5389 7.83164 21.2055 9.74164C21.8721 11.6516 21.9281 13.7217 21.3657 15.6649C20.8033 17.6082 19.6503 19.3284 18.0667 20.5871C17.934 20.6926 17.7695 20.75 17.6 20.75H6.4C6.23051 20.75 6.06602 20.6926 5.93333 20.5871C4.34966 19.3284 3.19674 17.6082 2.63434 15.6649C2.07195 13.7217 2.12793 11.6516 2.79453 9.74164C3.46113 7.83164 4.70534 6.17628 6.35474 5.00497Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5586_266">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WithdrawalIcon = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5586_492)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 21C2.25 20.5858 2.58579 20.25 3 20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H21C21.4142 9.25 21.75 9.58579 21.75 10C21.75 10.4142 21.4142 10.75 21 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7046 2.31064C11.8932 2.22979 12.1068 2.22979 12.2954 2.31064L19.2954 5.31064C19.6762 5.47381 19.8525 5.91472 19.6894 6.29544C19.5262 6.67616 19.0853 6.85253 18.7046 6.68936L12 3.81598L5.29544 6.68936C4.91472 6.85253 4.47381 6.67616 4.31064 6.29544C4.14748 5.91472 4.32384 5.47381 4.70456 5.31064L11.7046 2.31064Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 9.25C4.41421 9.25 4.75 9.58579 4.75 10V21C4.75 21.4142 4.41421 21.75 4 21.75C3.58579 21.75 3.25 21.4142 3.25 21V10C3.25 9.58579 3.58579 9.25 4 9.25Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 9.25C20.4142 9.25 20.75 9.58579 20.75 10V21C20.75 21.4142 20.4142 21.75 20 21.75C19.5858 21.75 19.25 21.4142 19.25 21V10C19.25 9.58579 19.5858 9.25 20 9.25Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 13.25C8.41421 13.25 8.75 13.5858 8.75 14V17C8.75 17.4142 8.41421 17.75 8 17.75C7.58579 17.75 7.25 17.4142 7.25 17V14C7.25 13.5858 7.58579 13.25 8 13.25Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V14C11.25 13.5858 11.5858 13.25 12 13.25Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 13.25C16.4142 13.25 16.75 13.5858 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75C15.5858 17.75 15.25 17.4142 15.25 17V14C15.25 13.5858 15.5858 13.25 16 13.25Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5586_492">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PromotionIcon = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5586_510)">
        <path
          d="M11.1382 19.7509C10.3964 19.7509 9.69819 19.4618 9.17455 18.9382L3.06 12.8236C2.53637 12.3 2.24728 11.6018 2.24728 10.86V8.02362C2.24728 6.49089 3.49091 5.24725 5.02364 5.24725H7.86C8.59091 5.24725 9.30546 5.5418 9.81819 6.05998L15.9327 12.1745C16.4564 12.6982 16.7455 13.3963 16.7455 14.1382C16.7455 14.88 16.4564 15.5782 15.9327 16.1018L13.1018 18.9327C12.5782 19.4563 11.88 19.7454 11.1382 19.7454V19.7509ZM5.02364 6.74725C4.32 6.74725 3.74728 7.31998 3.74728 8.02362V10.86C3.74728 11.1982 3.87819 11.52 4.11819 11.76L10.2327 17.8745C10.4727 18.1145 10.7945 18.2509 11.1327 18.2509C11.4709 18.2509 11.7927 18.12 12.0327 17.8745L14.8691 15.0382C15.1091 14.7982 15.2455 14.4763 15.2455 14.1382C15.2455 13.8 15.1145 13.4782 14.8691 13.2382L8.75455 7.12362C8.52 6.88362 8.18728 6.75271 7.85455 6.75271H5.01819L5.02364 6.74725Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          d="M17.5745 19.1563C17.3836 19.1563 17.1927 19.0854 17.0455 18.9382C16.7509 18.6436 16.7509 18.1691 17.0455 17.88L19.8818 15.0436C20.3782 14.5472 20.3782 13.74 19.8818 13.2382L12.7636 6.11997C12.4691 5.82543 12.4691 5.35088 12.7636 5.06179C13.0582 4.76724 13.5327 4.76724 13.8273 5.06179L20.9455 12.18C22.0255 13.26 22.0255 15.0218 20.9455 16.1072L18.1091 18.9436C17.9618 19.0909 17.7709 19.1618 17.58 19.1618L17.5745 19.1563Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          d="M6 9.74728H5.98909C5.57455 9.74728 5.23637 9.40909 5.23637 8.99455C5.23637 8.58 5.57455 8.24182 5.98909 8.24182C6.40364 8.24182 6.74182 8.58 6.74182 8.99455C6.74182 9.40909 6.40909 9.74728 5.99455 9.74728H6Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5586_510">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoutIcon = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5586_523)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.75C11.6685 4.75 11.3505 4.8817 11.1161 5.11612C10.8817 5.35054 10.75 5.66848 10.75 6V8C10.75 8.41421 10.4142 8.75 10 8.75C9.58579 8.75 9.25 8.41421 9.25 8V6C9.25 5.27065 9.53973 4.57118 10.0555 4.05546C10.5712 3.53973 11.2707 3.25 12 3.25H19C19.7293 3.25 20.4288 3.53973 20.9445 4.05546C21.4603 4.57118 21.75 5.27065 21.75 6V18C21.75 18.7293 21.4603 19.4288 20.9445 19.9445C20.4288 20.4603 19.7293 20.75 19 20.75H12C11.2707 20.75 10.5712 20.4603 10.0555 19.9445C9.53973 19.4288 9.25 18.7293 9.25 18V16C9.25 15.5858 9.58579 15.25 10 15.25C10.4142 15.25 10.75 15.5858 10.75 16V18C10.75 18.3315 10.8817 18.6495 11.1161 18.8839C11.3505 19.1183 11.6685 19.25 12 19.25H19C19.3315 19.25 19.6495 19.1183 19.8839 18.8839C20.1183 18.6495 20.25 18.3315 20.25 18V6C20.25 5.66848 20.1183 5.35054 19.8839 5.11612C19.6495 4.8817 19.3315 4.75 19 4.75H12Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.53033 8.46967C6.82322 8.76256 6.82322 9.23744 6.53033 9.53033L4.81066 11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H3C2.69665 12.75 2.42318 12.5673 2.30709 12.287C2.191 12.0068 2.25517 11.6842 2.46967 11.4697L5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.46967 11.4697C2.76256 11.1768 3.23744 11.1768 3.53033 11.4697L6.53033 14.4697C6.82322 14.7626 6.82322 15.2374 6.53033 15.5303C6.23744 15.8232 5.76256 15.8232 5.46967 15.5303L2.46967 12.5303C2.17678 12.2374 2.17678 11.7626 2.46967 11.4697Z"
          fill={active ? "#255eaa" : "#2C2C2C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5586_523">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
